/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {
  Component,
  Input,
} from '@angular/core';


@Component({
  selector: 'ls-skiplinks',
  standalone: true,
  templateUrl: './skiplinks.component.html',
  styleUrls: ['./skiplinks.component.scss'],
  imports: [
  ]
})
export class SkiplinksComponent {
  @Input() links: {id: string, name: string}[] = [];

  constructor() { }

  goto(id: string): void {
    const element = document.querySelector('#' + id);
    if (element) {
      window.setTimeout(() => (element as HTMLElement).focus(), 0);
    }
  }
}
